<template>
    <div
        class="sidebar-panel"
        @mouseleave="sidebarCompact"
        @mouseenter="removeSidebarCompact"
        :class="{
            'vertical-sidebar-compact': getVerticalCompact.isSidebarCompact,
            'sidebar-full-collapse': getVerticalSidebar.isMobileCompact,
        }"
    >
        <div class="border border-white">
            <div class="text-center d-flex align-items-center pl-2 mb-2 justify-content-between" >
                <div class="flex-shrink-0">
                    <router-link
                        :to="'/happiness/dashboard'"
                    >
                        <img
                            :class="['sidebar-logo', {
                                'compact-logo': getVerticalCompact.isSidebarCompact,
                            }]"
                            src="/static/img/logo/small.png"
                        />
                    </router-link>
                </div>

                <!-- <div v-show="!getVerticalCompact.isSidebarCompact" class="toggle-sidebar-compact">
                    <label class="switch ul-switch switch-primary ml-auto">
                        <input @click="switchSidebar" type="checkbox" />
                        <span class="ul-slider o-hidden"></span>
                    </label>
                </div> -->
            </div>

            <div class="close-mobile-menu" @click="mobileSidebar">
                <i class="text-16 text-primary i-Close-Window font-weight-bold" ></i>
            </div>

            <div class="mt-4 main-menu">
                <ul class="ul-vertical-sidebar pl-4" id="menu">
                    <li
                        class="Ul_li--hover"
                        v-for="item in items"
                        :key="`menu-item-${item.name}`"
                    >
                        <div
                            v-if="item.children.length && !isUser"
                            v-b-toggle="`collapse-${item.id}`"
                        >
                            <a
                                class="has-arrow"
                                href="#"
                            >
                                <i :class="['text-20 mr-2', item.icon]"></i>
                                <span v-show="!getVerticalCompact.isSidebarCompact" class="text-15" >
                                    {{ item.name }}
                                </span>
                                <arrowIcon />
                            </a>
                        </div>
                        <b-collapse
                            v-if="item.children.length && !isUser"
                            :visible="item.hasOwnProperty('visible') ? item.visible : false"
                            :id="`collapse-${item.id}`"
                        >
                            <ul
                                v-show="!getVerticalCompact.isSidebarCompact"
                                class="Ul_collapse"
                            >
                                <li
                                    v-for="children in item.children"
                                    :key="`children-${children.name}`"
                                    class="text-left"
                                >
                                    <router-link tag="a" :to="children.to" >
                                        <i :class="['mr-2', children.icon]"></i>
                                        <span>{{ children.name }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </b-collapse>
                        <router-link
                            v-if="!item.children.length && !isUser"
                            :to="item.to"
                            class="has-arrow"
                        >
                            <i :class="['nav-icon text-20 mr-2 text-muted', item.icon]" ></i>
                            <span v-show="!getVerticalCompact.isSidebarCompact" class="text-15 text-muted" >
                                {{ item.name }}
                            </span>
                        </router-link>
                        <!-- Temporary only for user, not admin -->
                    </li>
                    <li
                        class="Ul_li--hover"
                        v-if="isUser"
                    >
                        <router-link
                            :to="{ name: 'Profile' }"
                            class="has-arrow"
                        >
                            <i class="nav-icon text-20 mr-2 text-muted i-Administrator"></i>
                            <span v-show="!getVerticalCompact.isSidebarCompact" class="text-15 text-muted" >
                                Perfil
                            </span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import arrowIcon from '@/components/arrow/arrowIcon'
export default {
    components: {
        arrowIcon,
    },
    data () {
        return {
            selectedParentMenu: '',
            items: [
                {
                    name: 'Dashboard',
                    id: 'happiness_dashboard',
                    icon: 'i-Dashboard',
                    to: '/happiness/dashboard',
                    children: [],
                },
                /* {
                    name: 'Happiness Monitor',
                    id: 'happiness_monitor',
                    visible: true,
                    icon: 'i-Happy',
                    to: '/happiness/dashboard',
                    children: [ */
                {
                    name: 'Configurações',
                    icon: 'i-Gear',
                    to: '/happiness/settings',
                    children: [],
                },
                {
                    name: 'Milestones',
                    id: 'milestones',
                    icon: 'i-Map-Marker',
                    to: '/milestones',
                    children: [],
                },
                {
                    name: 'Relatórios',
                    icon: 'i-Data-Search',
                    to: '/happiness/reports',
                    children: [],
                },
                // ],
                // },
                {
                    name: 'Equipes',
                    id: 'teams',
                    icon: 'i-Business-Mens',
                    to: '/teams/list',
                    children: [],
                },
                {
                    name: 'Usuários',
                    id: 'users',
                    icon: 'i-Business-ManWoman',
                    to: '/users/list',
                    children: [],
                },
                /* {
                    name: 'Ajuda',
                    id: 'help',
                    icon: 'i-Ambulance',
                    to: '/help',
                    children: [],
                }, */
            ],
        }
    },
    computed: {
        ...mapGetters(['getVerticalCompact', 'getVerticalSidebar']),
        user () {
            return this.$store.getters['auth/user']
        },
        isUser () {
            return this.user && this.user.claims.level === 'user'
        },
    },
    // mounted () {
    //     this.toggleSelectedParentMenu()
    //     document.addEventListener('click', this.returnSelectedParentMenu)
    // },
    // beforeDestroy () {
    //     document.removeEventListener('click', this.returnSelectedParentMenu)
    // },
    methods: {
        ...mapActions([
            'switchSidebar',
            'sidebarCompact',
            'removeSidebarCompact',
            'mobileSidebar',
        ]),

        // toggleSelectedParentMenu () {
        //     const currentParentUrl = this.$route.path
        //         .split('/')
        //         .filter((x) => x !== '')[1]

        //     if (currentParentUrl) {
        //         this.selectedParentMenu = currentParentUrl.toLowerCase()
        //     } else {
        //         this.selectedParentMenu = 'dashboards'
        //     }
        // },
        // returnSelectedParentMenu () {
        //     this.toggleSelectedParentMenu()
        // },
    },
}
</script>

<style lang="scss">
.sidebar-panel {
    .sidebar-logo {
        width: 140px;
        transition-property: width;
        transition-duration: 300ms;
        &.compact-logo {
            width: 60px;
        }
    }
}
</style>
